/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const DeleteNotificationPolicyHeaders = zod.object({
  'x-csrf-token': zod.string(),
  'Idempotency-Key': zod.string(),
});

export type DeleteNotificationPolicyHeaders = zod.input<typeof DeleteNotificationPolicyHeaders>;
export type DeleteNotificationPolicyHeadersOutput = zod.output<
  typeof DeleteNotificationPolicyHeaders
>;
